import "./DadosSindicato.css";
import { formatCnpj } from "../../../../../utils";

interface DadosSindicatoProps {
  DadosSindicato?: {
    cnpj?: string;
    nome?: string;
    nomeSindicato?: string;
    sigla?: string;
  };
  readOnly?: boolean;
}

const DadosSindicato = ({ DadosSindicato }: DadosSindicatoProps) => {
  const nome = DadosSindicato?.nomeSindicato || DadosSindicato?.nome || "";

  return (
    <div className="card shadow-sm p-4 mb-4 dados-sindicato card-rounded">
      <h5 className="fw-bold text-uppercase pb-2 mb-3 text-primary">
        Dados do Sindicato
      </h5>

      <div className="row">
        <div className="col-12 mb-3">
          <label className="form-label fw-semibold">NOME DO SINDICATO</label>
          <input
            type="text"
            className="form-control"
            value={nome}
            readOnly
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">CNPJ</label>
          <input
            type="text"
            className="form-control"
            value={formatCnpj(DadosSindicato?.cnpj || "")}
            readOnly
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">SIGLA</label>
          <input
            type="text"
            className="form-control"
            value={DadosSindicato?.sigla || ""}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default DadosSindicato;
